var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CompareEqual } from './modules/CompareEqual';
import { CompareRegex } from './modules/CompareRegex';
import { CompareNumber } from './modules/CompareNumber';
import { CompareIncludes } from './modules/CompareIncludes';
import { CompareLevensthein } from './modules/CompareLevenshtein';
import { CompareLength } from './modules/CompareLength';
import { CompareSimilarText } from './modules/CompareSimilarText';
import { DisproveNumber } from './modules/DisproveNumber';
import { OverallSimilar } from './modules/OverallSimilar';
import { Parse } from './modules/Parse';
import { OverallConflict } from './modules/OverallConflict';
import { ParseUserInput } from './modules/ParseInput';
import { DisproveAccuracy100 } from './modules/DisproveAccuracy100';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { DisproveSimilarText } from './modules/DisproveSimilarText';
import { CompareStartsWith } from './modules/CompareStartsWith';
export class Comparer {
    wording;
    constructor(wording) {
        this.wording = wording;
    }
    get wordTask() {
        return this.wording.wordTask;
    }
    get userInput() {
        return '';
    }
    get rawExpectedInput() {
        return this.wording.wordingString;
    }
    get cleanedExpectedInput() {
        return this.wording.wordingCleaner.cleanedString;
    }
    get parseExpect() {
        return new Parse(this);
    }
    get parseUserInput() {
        return new ParseUserInput(this);
    }
    get compareEqual() {
        return new CompareEqual(this);
    }
    get compareIncludes() {
        return new CompareIncludes(this);
    }
    get compareStartsWith() {
        return new CompareStartsWith(this);
    }
    get compareLength() {
        return new CompareLength(this);
    }
    get compareLevenshtein() {
        return new CompareLevensthein(this);
    }
    get compareNumber() {
        return new CompareNumber(this);
    }
    get compareRegex() {
        return new CompareRegex(this);
    }
    get compareSimilarText() {
        return new CompareSimilarText(this);
    }
    get overallSimilar() {
        return new OverallSimilar(this);
    }
    get disproveNumber() {
        return new DisproveNumber(this);
    }
    get disproveAccuracy100() {
        return new DisproveAccuracy100(this);
    }
    get disproveSimilarText() {
        return new DisproveSimilarText(this);
    }
    get overallConflict() {
        return new OverallConflict(this);
    }
}
__decorate([
    memoize
], Comparer.prototype, "parseExpect", null);
__decorate([
    memoize
], Comparer.prototype, "parseUserInput", null);
__decorate([
    memoize
], Comparer.prototype, "compareEqual", null);
__decorate([
    memoize
], Comparer.prototype, "compareIncludes", null);
__decorate([
    memoize
], Comparer.prototype, "compareStartsWith", null);
__decorate([
    memoize
], Comparer.prototype, "compareLength", null);
__decorate([
    memoize
], Comparer.prototype, "compareLevenshtein", null);
__decorate([
    memoize
], Comparer.prototype, "compareNumber", null);
__decorate([
    memoize
], Comparer.prototype, "compareRegex", null);
__decorate([
    memoize
], Comparer.prototype, "compareSimilarText", null);
__decorate([
    memoize
], Comparer.prototype, "overallSimilar", null);
__decorate([
    memoize
], Comparer.prototype, "disproveNumber", null);
__decorate([
    memoize
], Comparer.prototype, "disproveAccuracy100", null);
__decorate([
    memoize
], Comparer.prototype, "disproveSimilarText", null);
__decorate([
    memoize
], Comparer.prototype, "overallConflict", null);
